export const data = [
  {
    id: 1,
    title: 'Definitions and Interpretation',
    paragraphs: [
      {
        id: 1,
        text: 'In this agreement "we" means The Cumin Club (and "us" and "our" shall be construed accordingly); and "you" means the relevant customer or potential customer as the case may be (and "your" shall be construed accordingly).',
      },
      {
        id: 2,
        text: 'In this agreement, the following definitions shall apply:',
        list: [
          {
            id: 1,
            text: '"agreement" means this agreement incorporating any terms set out in our second acknowledgement;',
          },
          {
            id: 2,
            text: '"first acknowledgement" means the initial automatic email acknowledgment which we will send to you after receiving your order;',
          },
          {
            id: 3,
            text: '"order" means your order for products made via the site;',
          },
          {
            id: 4,
            text: '"products" means goods which may be purchased by you from the site;',
          },
          {
            id: 5,
            text: '"second acknowledgement" means the email acknowledgment which we will send to you (where appropriate) confirming acceptance of your order; and',
          },
          {
            id: 6,
            text: '"site" means the website at www.thecuminclub.com or any successor site operated by us from time to time.',
          },
        ],
      },
    ],
  },
  {
    id: 2,
    title: 'This Agreement',
    paragraphs: [
      {
        id: 1,
        text: 'The advertising of products on the site constitutes an "invitation to treat"; and your order for products constitutes a contractual offer. No contract comes into force between you and us unless and until we accept your order.',
      },
      {
        id: 2,
        text: 'In order to enter into this Agreement with us, you will need to take the following steps:',
      },
      {
        id: 3,
        text: 'You must add any the products you wish to purchase to your shopping cart, and then proceed to the checkout to confirm your order. We will then send you the first acknowledgement and once we have checked whether we are able to meet your order, we will either send you the second acknowledgement (at which point this Agreement will become a binding contract) or we will confirm by email that we are unable to meet your order.',
      },
      {
        id: 4,
        text: 'Please note that we will not file a copy of this agreement. We may update the version of this Agreement on the site from time to time, and we do not guarantee that the version you have agreed to will remain accessible. We therefore recommend that you download, print and retain a copy of this agreement for your records.',
      },
      {
        id: 5,
        text: 'The only language in which we offer this agreement is English.',
      },
      {
        id: 6,
        text: 'Before you place your order, you will have the opportunity of identifying whether you have made any input errors by reviewing your shopping cart. You may correct those input errors before placing your order.',
      },
    ],
  },
  {
    id: 3,
    title: 'About Us',
    paragraphs: [
      {
        id: 1,
        text: 'This website is operated by TCC BRANDS INC, Chicago, IL. Our email address is hello@thecuminclub.com.',
      },
    ],
  },
  {
    id: 4,
    title: 'The Products',
    paragraphs: [
      {
        id: 1,
        text: 'The products and services listed in The Cumin Club are Indian authentic meals related which falls under the category of food and snacks. These products or services are sourced from their respective manufacturers or providers in India.',
      },
    ],
  },
  {
    id: 5,
    title: 'Price and Payment',
    paragraphs: [
      {
        id: 1,
        text: "Prices for products are quoted on the site. We will verify prices as part of our sale procedures so that a product's correct price will be stated in the second acknowledgement/when you pay for the product.",
      },
      {
        id: 2,
        text: 'In addition to the price of the products, you will have to pay a delivery charge in some cases, which will be as stated in the second acknowledgement when you pay for the product. We may withhold the products and/or terminate this agreement if the price is not received from you in full, on time, in cleared funds.',
      },
      {
        id: 3,
        text: 'Payment for all products must be made by credit/debit card OR any method detailed on the site from time to time.',
      },
      {
        id: 4,
        text: 'Prices for products are liable to change at any time, but changes will not affect agreements which have come into force.',
      },
    ],
  },
  {
    id: 6,
    title: 'Delivery',
    paragraphs: [
      {
        id: 1,
        text: 'We will arrange for the products to be delivered to the address for delivery indicated in your order.',
      },
      {
        id: 2,
        text: 'We will use reasonable endeavours to deliver products on or before the date for delivery set out in our second acknowledgement or, if no date is set out in our second acknowledgement, within 5 days of the date of our second acknowledgement. However, we cannot guarantee delivery by the relevant date. We do however guarantee that unless there are exceptional circumstances all deliveries of products will be dispatched within 5 days of the later of receipt of payment and the date of our second acknowledgement.',
      },
      {
        id: 3,
        text: 'Customer is responsible for the customs clearance in the respective destinations and please check whether this product is allowed to enter in to your country before placing the order. We will not refund any amount if the shipment is returned by the customs. We will keep the receipt of dispatch and it should be treated as the document of proof for the dispatch.',
      },
    ],
  },
  {
    id: 7,
    title: 'Risk and Title',
    paragraphs: [
      {
        id: 1,
        text: 'The products will be at your risk from the time of dispatch. Ownership of the products will only pass to you after we receive full payment of all sums due in respect of the Products (including delivery charges).',
      },
    ],
  },
  {
    id: 8,
    title: 'Consumer Rights',
    paragraphs: [
      {
        id: 1,
        text: 'You may cancel this agreement at any time within 2 working days after the day you received the products (subject to the limitations set out below).',
      },
      {
        id: 2,
        text: 'You will not have any such right insofar as this Agreement relates to: (i) the products which have been unsealed by you; (ii) the products which are specifically manufactured as per your order and consent; or (iii) the herbs collected and processed for you.',
      },
      {
        id: 3,
        text: 'If you cancel this agreement on this basis, you must inform us in writing and return the products to us immediately, in the same condition in which you received them. Products returned by you within the 2 working day period referred to above will be refunded in full (including the cost of sending the products to you).',
      },
      {
        id: 4,
        text: 'A photo copy of the product with damages shown or capturing your complaints should be shared with us to start the refund process.  Refund will be processed solely depending upon our acceptance of your complaint.',
      },
    ],
  },
  {
    id: 9,
    title: 'Defective Products',
    paragraphs: [
      {
        id: 1,
        text: 'You may also cancel this agreement if the products supplied are defective.',
      },
      {
        id: 2,
        text: 'Products returned by you because of a defect will be refunded in full (including the cost of sending the products to you, and the cost of returning the products to us). Alternatively, if we and you agree, we may supply you with a replacement or substitute product.',
      },
    ],
  },
  {
    id: 10,
    title: 'Refunds and Cancellation',
    paragraphs: [
      {
        id: 1,
        text: 'Any of the order placed with www.thecuminclub.com will be subject to cancellation before shipping. Any cancellation request should reach us before the shipping of the products. This will not apply to custom packed products that are packed specially for a customer. In such cases cancellation will not be entertained. If the order was cancelled before shipment the refund will be 100%. Any refund request will get processed with in a day of accepting the cancellation policy.',
      },
      {
        id: 2,
        text: 'If you cancel this agreement and are entitled to a refund, we will usually refund any money received from you using the same method originally used by you to pay for your purchase. We will process the refund due to you as soon as possible and, in any event, within 10 days of the day we received your notice of cancellation.',
      },
    ],
  },
  {
    id: 11,
    title: 'Warranties',
    paragraphs: [
      {
        id: 1,
        text: 'We warrant to you that any product you purchase through the site will be of satisfactory quality.',
      },
      {
        id: 2,
        text: 'You warrant to us that: you have full authority, power and capacity to enter into this agreement and that all necessary actions have been taken to enable you to lawfully enter into this Agreement; you are legally capable of entering into binding contracts; you are at least 18 years old; the information provided in the order is accurate; and you will be able to accept delivery of the products as contemplated in this agreement.',
      },
      {
        id: 3,
        text: 'Subject to the warranties set out in above, to the maximum extent permitted by applicable law we disclaim all warranties with respect to the products, whether express or implied.',
      },
    ],
  },
  {
    id: 12,
    title: 'Limitations of Liability',
    paragraphs: [
      {
        id: 1,
        text: 'Nothing in this agreement shall limit or exclude your or our liability for: (i) death or personal injury caused by negligence; (ii) under section 12 of the Sale of Goods Act 1979, section 2 of the Supply of Goods and Services Act 1982, or section 2(3) of the Consumer Protection Act 1987; (iii) for fraud or fraudulent misrepresentation; or (iv) for any matter for which it would be illegal for to limit or exclude, or attempt to limit or exclude, liability. Subject to this: (i) our liability in connection with any Product purchased through our site is strictly limited to the higher of the purchase price of the relevant Product and the replacement cost of the relevant Product; (ii) we accept no liability for any loss of income or revenue, loss of business, loss of profits or contracts, loss of anticipated savings, loss of data, waste of management or office time or for any indirect or consequential loss or damage of any kind however arising and whether caused by tort (including negligence), breach of contract or otherwise, even if foreseeable; and (iii) we will not be liable or responsible for any failure to perform, or delay in performance of, any of our obligations under this Agreement caused by events outside our reasonable control.',
      },
    ],
  },
  {
    id: 13,
    title: 'Privacy Policy',
    paragraphs: [
      {
        id: 1,
        text: 'All the information we stored on the customer will be private to www.thecuminclub.com and will not be shared with any other parties.  All Personal identifiable Information (PII) are handled in a secured way and will not be exposed to any other parties.  Website is SSL enabled to secured the transaction details.  We will not store credit/debit/bank account details.',
      },
    ],
  },
  {
    id: 14,
    title: 'General Terms',
    paragraphs: [
      {
        id: 1,
        text: 'Images of products on the site are for illustrative purposes; actual products may differ from such images. We will treat all your personal information that we collect in connection with your order in accordance with the terms of our privacy policy, use of our website will be subject to our website terms and conditions. This agreement may only be varied by an instrument in writing signed by both you and us. We may revise these terms from time-to-time, but such revisions will not affect the terms of any agreement which we have entered into with you.',
      },
      {
        id: 2,
        text: 'If any provision of this agreement is held invalid or unenforceable by a court of competent jurisdiction, the remaining provisions of this agreement shall remain in full force and effect, and such invalid or unenforceable provisions or portion thereof shall be deemed omitted. ',
      },
      {
        id: 3,
        text: 'No waiver of any term, provision, or condition of this agreement, whether by conduct or otherwise, in any one or more instances, will be deemed to be, or be construed as, a further or continuing waiver of that term, provision or condition or any other term, provision or condition of this agreement.',
      },
      {
        id: 4,
        text: 'You may not assign, charge, sub-contract or otherwise transfer this agreement, or any of your rights or obligations arising under this agreement. Any attempt by you to do so shall be null and void. We may assign, charge, sub-contract or otherwise transfer this agreement, or any of our rights or obligations arising under this agreement, at any time - providing such action does not serve to reduce the guarantees benefiting you under this agreement. This agreement is made for the benefit of the parties to it and is not intended to benefit, or be enforceable by, any other person. The rights of the parties to terminate, rescinds, or agree any amendment, variation, waiver or settlement under this agreement is not subject to the consent of any person who is not a party to this agreement.',
      },
      {
        id: 5,
        text: 'This agreement contains the complete agreement between the parties with respect to the subject matter hereof, and supersedes all prior or contemporaneous agreements or understandings, whether oral or written.',
      },
    ],
  },
];
